import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  AppSelect,
  AppSearchSectionSelect,
} from "../../../components/appComponents";
// import Common from "../../../helper/common";
import { Button } from "../../../components/ui/button";

import {
  PaymentTypeEnum,
  TransactionLogStatusEnum,
  TransactionLogTypeEnum,
  TransactionSourceEnum,
  ViewDateFormat,
  ViewDateTimeFormat,
  ViewTimeOnly,
  respEnum,
} from "../../../constants/appConstant";
import AdvanceTable from "../../../components/advanceTable";
import Common from "../../../helper/common";
import common from "../../../helper/common";

const TransactionLogs = () => {
  const [data, setData] = useState({});
  // const [courtId, setCourtId] = useState(null);
  const [status, setStatus] = useState(null);
  const [transactionType, setTransactionType] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [clubAccountId, setclubAccountId] = useState(null);
  const [byClub, setbyClub] = useState(null);
  const [transactionSource, setTransactionSource] = useState(null);

  const [paymentTypeList, setPaymentTypeList] = useState([]);

  useEffect(() => {
    getData(1);
    Common.delay();
    getClubPaymentTypes();
  }, []);

  useEffect(() => {
    getData(1);
    getClubPaymentTypes();
  }, [
    status,
    transactionType,
    paymentType,
    clubAccountId,
    byClub,
    transactionSource,
  ]);

  // const getCourts = async () => {
  //   const response = await Common.ApiService.getInstance().request(
  //     "GetCourtddl"
  //   );
  //   const courts = [{ id: null, name: "All" }, ...(response?.data ?? [])];
  //   setCourtList(courts);
  // };

  const resetFilters = () => {
    setStatus(null);
    setTransactionType(null);
    setPaymentType(null);
    setclubAccountId(null);
    setbyClub(null);
    setTransactionSource(null);
  };
  debugger;
  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    global.log(byClub);
    const response = await Common.ApiService.getInstance().request(
      "GetTransactionLogs",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        status,
        transactionType,
        paymentType,
        clubAccountId: clubAccountId ? clubAccountId.value : null,
        byClub: byClub,
        transaction_source: transactionSource,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          bookingDate: item.bookingDate
            ? `${moment(item.bookingDate).format(ViewDateFormat)}`
            : "-",
          // createdOn: `${moment(item.createdOn).format(ViewDateTimeFormat)}`,
          createdOn: Common.Utility.ConvertTime(item.createdOn),
          isByClub: item.isByClub ? "Yes" : "No",
          isPlayerCancel: item.isPlayerCancel ? "Yes" : "No",
          isTimeOut: item.isTimeOut ? "Yes" : "No",
          startDateTime: item.startDateTime
            ? `${moment(item.startDateTime).format(ViewTimeOnly)}`
            : "-",
          endDateTime: item.endDateTime
            ? `${moment(item.endDateTime).format(ViewTimeOnly)}`
            : "-",
          //updatedOn: item.updatedOn
          //  ? `${moment(item.updatedOn).format(ViewDateTimeFormat)}`
          //      : "-",

          updatedOn: item.updatedOn
            ? Common.Utility.ConvertTime(item.updatedOn)
            : "-",
          position: item.position ?? "-",
          side: item.side ?? "-",
          err_code: item.err_code ?? "-",
          err_message: item.err_message ?? "-",
          paymentType: Common.Utility.getKeyByValue(
            PaymentTypeEnum,
            item.paymentType
          ),
          status: Common.Utility.getKeyByValue(
            TransactionLogStatusEnum,
            item.status
          ),
          transactionType: Common.Utility.getKeyByValue(
            TransactionLogTypeEnum,
            item.transactionType
          ),
          transaction_source: Common.Utility.getKeyByValue(
            TransactionSourceEnum,
            item.transaction_source ?? TransactionSourceEnum.Booking
          ),
          player_number:item.player_number??"-",
        })),
      };

      setData(obj);
    }
  };

  const getClubPaymentTypes = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubPaymentTypes"
    );

    if (response?.status == respEnum.Success) {
      setPaymentTypeList(response?.data ?? []);
    }
  };

  // const _addUpdateTrigger = () => (
  //   <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
  //     <Icon icon="heroicons:pencil" className="h-4 w-4" />
  //   </Button>
  // );

  // const actions = [
  //   {
  //     type: "view",
  //     onClick: (val) => {
  //       router.push(`/ clubbookings / detail ? id = ${ val.id }`, {});
  //     },
  //   },
  // ];

  let columns = [
    { title: "Basket ID", type: "text", key: "basketId" },
    { title: "Player Name", type: "text", key: "playerName" },
    { title: "Player Number", type: "text", key: "player_number" },

    { title: "Amount", type: "text", key: "amount" },
    { title: "Status", type: "text", key: "status" },
    { title: "Transaction Type", type: "text", key: "transactionType" },
    { title: "Court", type: "text", key: "courtName" },
    { title: "CreatedOn", type: "text", key: "createdOn" },
    { title: "Booking/Order Date", type: "text", key: "bookingDate" },
    { title: "Start", type: "text", key: "startDateTime" },
    { title: "End", type: "text", key: "endDateTime" },
    { title: "By Club", type: "text", key: "isByClub" },
    { title: "Player Cancelled", type: "text", key: "isPlayerCancel" },
    { title: "Payment Type", type: "text", key: "paymentTypeName" },
    { title: "Payment Account", type: "text", key: "clubAccountName" },
    // Transaction Source Type
    {
      title: "Transaction Source",
      type: "text",
      key: "transaction_source",
    },

    { title: "Error Message", type: "text", key: "err_message" },
    { title: "Error Code", type: "text", key: "err_code" },
    { title: "Position", type: "text", key: "position" },
    { title: "Side", type: "text", key: "side" },
    { title: "Completed On", type: "text", key: "updatedOn" },
  ];

  return (
    <>
      <div className="md:grid md:grid-cols-7 gap-3 ">
        {/* <AppSelect
          value={courtId}
          onChange={setCourtId}
          placeholder={"Select Court"}
          label={"Court"}
          data={courtList}
          className={"mb-5 col-span-1"}
        /> */}

        <AppSelect
          value={status}
          onChange={setStatus}
          label="Transaction Status"
          data={[
            { id: null, name: "Select" },
            ...Common.Utility.enumToArray(TransactionLogStatusEnum),
          ]}
          className="mb-5 col-span-1"
        />

        <AppSelect
          value={transactionType}
          onChange={setTransactionType}
          label="Transaction Type"
          data={[
            { id: null, name: "Select" },
            ...Common.Utility.enumToArray(TransactionLogTypeEnum),
          ]}
          className="mb-5 col-span-1"
        />

        <AppSelect
          value={paymentType}
          onChange={setPaymentType}
          label="Payment Type"
          data={[
            { id: null, name: "Select" },
            { id: PaymentTypeEnum.Cash, name: "Cash" },
            { id: PaymentTypeEnum.Online, name: "Online" },
            { id: PaymentTypeEnum.Payment_GateWay, name: "Payment GateWay" },
            //...Common.Utility.enumToArray(PaymentTypeEnum),
          ]}
          className="mb-5 col-span-1"
        />
        <AppSearchSectionSelect
          value={clubAccountId}
          onChange={setclubAccountId}
          label="Payment Account"
          data={paymentTypeList}
          className="mb-5 col-span-1"
        />
        <AppSelect
          value={byClub}
          onChange={setbyClub}
          label="By Club"
          data={[
            { id: null, name: "Select" },
            { id: true, name: "Yes" },
            { id: false, name: "No" },
          ]}
          className="mb-5 col-span-1"
        />

        <AppSelect
          value={transactionSource}
          onChange={setTransactionSource}
          label="Transaction Source"
          data={[
            { id: null, name: "Select" },
            ...Common.Utility.enumToArray(TransactionSourceEnum),
          ]}
          className="mb-5 col-span-1"
        />
        <Button className="mb-5 mt-6 h-8 col-span-1" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Transaction Logs"}
          columns={columns}
          data={data}
          getData={getData}
          showPagination
          showAddButton
          showExportoptions
        />
      )}
    </>
  );
};

export default TransactionLogs;
